import axios from 'axios';
import { tokenizedAxios } from './axiosInterceptor';

export const customAxios = async (requestObj) => {
    try {
        const response = await axios(requestObj);
        if (!response) {
            throw new Error('json parse error');
        }
        return response.data;
    } catch (error) {
        return { error: true };
    }
}

export const tokenizedRequest = async (requestObj) => {
    try {
        const response = await tokenizedAxios(requestObj);
        if (!response) {
            throw new Error('json parse error');
        }
        return response.data;
    } catch (error) {
        return { error: true, reason: error };
    }
}
